import React from 'react';
import { Row, Col, Label, Input } from 'reactstrap';

const WorkGeneralInfoForm = ({ workData }) => {
	return (
		<Row>
			{/* Columna 1 */}
			<Col md={6}>
				<div className='mb-3'>
					<Label htmlFor='establishment' className='form-label'>
						Establecimiento
					</Label>
					<Input
						type='text'
						className='form-control'
						id='establishment'
						value={workData?.establishment || '-'}
						disabled
					/>
				</div>

				<div className='mb-3'>
					<Label htmlFor='region' className='form-label'>
						Región
					</Label>
					<Input
						type='text'
						className='form-control'
						id='region'
						value={workData?.region || '-'}
						disabled
					/>
				</div>

				<div className='mb-3'>
					<Label htmlFor='water_right_status' className='form-label'>
						Estado del Derecho
					</Label>
					<Input
						type='text'
						className='form-control'
						id='water_right_status'
						value={workData?.water_right_status || '-'}
						disabled
					/>
				</div>

				<div className='mb-3'>
					<Label htmlFor='reporting_type' className='form-label'>
						Tipo de Reportabilidad
					</Label>
					<Input
						type='text'
						className='form-control'
						id='reporting_type'
						value={workData?.reporting_type || '-'}
						disabled
					/>
				</div>
				<div className='mb-3'>
					<Label htmlFor='reporting_frequency' className='form-label'>
						Frecuencia de Reportabilidad
					</Label>
					<Input
						type='text'
						className='form-control'
						id='reporting_frequency'
						value={workData?.reporting_frequency || '-'}
						disabled
					/>
				</div>
			</Col>

			{/* Columna 2 */}
			<Col md={6}>
				<div className='mb-3'>
					<Label htmlFor='water_right_number' className='form-label'>
						Número Derecho de Agua
					</Label>
					<Input
						type='text'
						className='form-control'
						id='water_right_number'
						value={workData?.water_right_number || '-'}
						disabled
					/>
				</div>

				<div className='mb-3'>
					<Label htmlFor='commune' className='form-label'>
						Comuna
					</Label>
					<Input
						type='text'
						className='form-control'
						id='commune'
						value={workData?.commune || '-'}
						disabled
					/>
				</div>

				<div className='mb-3'>
					<Label htmlFor='nature_classification' className='form-label'>
						Clasificación por Naturaleza
					</Label>
					<Input
						type='text'
						className='form-control'
						id='nature_classification'
						value={workData?.nature_classification || '-'}
						disabled
					/>
				</div>

				<div className='mb-3'>
					<Label htmlFor='work_code' className='form-label'>
						Código de Obra
					</Label>
					<Input
						type='text'
						className='form-control'
						id='work_code'
						value={workData?.work_code || '-'}
						disabled
					/>
				</div>

				
			</Col>
		</Row>
	);
};

export default WorkGeneralInfoForm;
